import React from 'react';
import { Check, XCircle } from 'lucide-react';

/**
 * EstadoProgress — barra de progreso del flujo del ticket.
 * Estados laterales (rechazado/descartado/rechazada) se muestran como banner rojo.
 *
 * // MANTENER SYNCED con backend services/flujosEstado.js
 */
const FLUJOS = {
  incidencia: {
    principales: ['pendiente', 'en_revision', 'en_desarrollo', 'resuelto'],
    laterales: ['rechazado', 'descartado'],
  },
  sugerencia: {
    principales: ['recibida', 'en_estudio', 'aceptada', 'implementada'],
    laterales: ['rechazada'],
  },
};
const LABEL = {
  pendiente: 'Pendiente', en_revision: 'En revisión', en_desarrollo: 'En desarrollo', resuelto: 'Resuelto',
  recibida: 'Recibida', en_estudio: 'En estudio', aceptada: 'Aceptada', implementada: 'Implementada',
  rechazado: 'Rechazado', descartado: 'Descartado', rechazada: 'Rechazada',
};

export default function EstadoProgress({ tipo, estado }) {
  const flujo = FLUJOS[tipo];
  if (!flujo) return null;

  // Estado lateral → banner, no barra.
  if (flujo.laterales.includes(estado)) {
    return (
      <div className="flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        <XCircle className="w-4 h-4 shrink-0" />
        Ticket {LABEL[estado]?.toLowerCase() || estado}
      </div>
    );
  }

  const pasos = flujo.principales;
  const activeIdx = pasos.indexOf(estado);

  return (
    <div className="flex items-center w-full">
      {pasos.map((p, i) => {
        const done = i < activeIdx;
        const current = i === activeIdx;
        const navy = done || current;
        return (
          <React.Fragment key={p}>
            <div className="flex flex-col items-center shrink-0">
              <span
                className={
                  'inline-flex items-center justify-center w-7 h-7 rounded-full text-[12px] font-semibold ' +
                  (navy ? 'bg-primary text-white' : 'bg-slate-100 text-slate-400')
                }
              >
                {done ? <Check className="w-3.5 h-3.5" strokeWidth={2.5} /> : i + 1}
              </span>
              <span className={'text-[11px] mt-1 whitespace-nowrap ' + (navy ? 'text-slate-900 font-medium' : 'text-slate-400')}>
                {LABEL[p] || p}
              </span>
            </div>
            {i < pasos.length - 1 && (
              <div className={'flex-1 h-px mx-2 -mt-4 ' + (i < activeIdx ? 'bg-primary' : 'bg-slate-200')} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
